import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-checked", "title", "disabled"]


export default /*@__PURE__*/_defineComponent({
  __name: 'BrandStatusSwitch',
  props: {
    active: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["toggle"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    role: "switch",
    "aria-checked": _ctx.active,
    title: _ctx.active ? 'Désactiver' : 'Activer',
    class: _normalizeClass(["relative inline-flex h-8 w-[52px] shrink-0 items-center rounded-full transition-colors duration-200 disabled:opacity-50", _ctx.active ? 'bg-[#34c759]' : 'bg-[#e9e9eb]']),
    disabled: _ctx.disabled,
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('toggle')), ["stop"]))
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["inline-block h-7 w-7 rounded-full bg-white shadow-[0_1px_2px_rgba(0,0,0,0.2)] transition-transform duration-200", _ctx.active ? 'translate-x-[22px]' : 'translate-x-0.5'])
    }, null, 2)
  ], 10, _hoisted_1))
}
}

})